import { useSelectedChain } from "@app/examples/ChainSelector";
import { useEffect, useState } from "react";
import { WasmX } from "wasmx";
import { useLCD } from "./LCDHook";

export function useWasmX(chainId?: string) {
    const lcd = useLCD(chainId)
    const { selectedChain } = useSelectedChain()
    const [wasmX, setWasmX] = useState<WasmX>()

    useEffect(() => {
        if (selectedChain && lcd) {
            setWasmX(new WasmX(lcd, selectedChain.chainId))
        }
    }, [selectedChain, lcd])

    return wasmX
}